import * as React from 'react';

import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';
import { useStyles } from './Image.styles';

type SkeletonType = 'rect' | 'circle';

type ImageProps = {
  src?: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  skeletonType?: SkeletonType;
};
const Image: React.FC<ImageProps> = ({
  src,
  className,
  width = '100%',
  height = '100%',
  skeletonType = 'rect',
  ...rest
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [isValid, setIsValid] = React.useState<boolean>(true);
  const styles = useStyles({
    width,
    height,
    isDefaultImage: !isValid,
  });

  const handleLoad = () => {
    setIsLoading(false);
    setIsValid(true);
  };

  const handleError = () => {
    setIsLoading(false);
    setIsValid(false);
  };

  return (
    <div className={clsx(styles.root, className)} {...rest}>
      {isLoading && <Skeleton variant={skeletonType} width={width} height={height} />}
      {isValid && <img className={styles.img} src={src} alt="img" onLoad={handleLoad} onError={handleError} />}
    </div>
  );
};

export default Image;
